import React from "react";

import i18n from "./i18n";
const tr = i18n.t.bind(i18n);
// Safe helpers (won’t crash Safari if Clipboard/matchMedia are missing)
function copy(text) {
  try {
    if (navigator?.clipboard?.writeText) return navigator.clipboard.writeText(text);
  } catch {}
  // Fallback
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.top = "-1000px";
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try { document.execCommand("copy"); } catch {}
  document.body.removeChild(ta);
}

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, info: null, expanded: true };

  static getDerivedStateFromError(error) {
    // Update state so next render shows the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log to console (and optionally to your backend)
    try { console.error("ErrorBoundary caught:", error, info); } catch {}
    this.setState({ info });
    // OPTIONAL: send to server
    // fetch("/api/log/client-error", { method:"POST", headers:{ "Content-Type":"application/json" }, body: JSON.stringify({ message: String(error?.message || error), stack: String(error?.stack || ""), componentStack: String(info?.componentStack || ""), path: window.location?.href }) }).catch(()=>{});
  }

  handleReload = () => window.location.reload();
  handleHome   = () => { try { window.location.assign("/"); } catch { window.location.href = "/"; } };
  toggleDetails = () => this.setState(s => ({ expanded: !s.expanded }));
  copyDetails = () => {
    const { error, info } = this.state;
    const text =
tr(
  'Path: {{var1}} Message: {{var2}} Name: {{var3}} Stack: {{var4}} Component stack: {{var5}}',
  {
    var1: window.location?.href,
    var2: String(error?.message || error),
    var3: String(error?.name || "Error"),
    var4: String(error?.stack || "(no stack)"),
    var5: String(info?.componentStack || "(no component stack)")
  }
);
    copy(text);
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, info, expanded } = this.state;
    const message = String(error?.message || error || "Unknown error");
    const stack = String(error?.stack || "");
    const componentStack = String(info?.componentStack || "");

    return (
      <div style={{
        maxWidth: 900, margin: "40px auto", padding: 16,
        fontFamily: "-apple-system, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
        lineHeight: 1.45
      }}>
        <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
        <p style={{ color: "#b91c1c", whiteSpace: "pre-wrap" }}>
          {message}
        </p>

        <div style={{ display: "flex", gap: 8, margin: "12px 0" }}>
          <button onClick={this.handleReload} style={btnPrimary}>Reload</button>
          <button onClick={this.handleHome} style={btnGhost}>Go to Home</button>
          <button onClick={this.toggleDetails} style={btnGhost}>
            {expanded ? "Hide details" : "Show details"}
          </button>
          <button onClick={this.copyDetails} style={btnGhost}>Copy details</button>
        </div>

        {expanded && (
          <div style={panel}>
            <div style={label}>Stack trace</div>
            <pre style={pre}>{stack || "(no stack)"}</pre>
            <div style={label}>Component stack</div>
            <pre style={pre}>{componentStack || "(no component stack)"}</pre>
          </div>
        )}

        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 12 }}>
          Tip: enable source maps in production so file names/line numbers are readable.
        </div>
      </div>
    );
  }
}

const btnPrimary = {
  padding: "8px 12px", borderRadius: 8, border: 0, background: "#2563eb", color: "#fff", cursor: "pointer"
};
const btnGhost = {
  padding: "8px 12px", borderRadius: 8, border: "1px solid #d1d5db", background: "#fff", cursor: "pointer"
};
const panel = { border: "1px solid #e5e7eb", borderRadius: 10, padding: 12, background: "#fafafa" };
const label = { fontWeight: 600, marginTop: 8, marginBottom: 4, color: "#374151" };
const pre = { margin: 0, whiteSpace: "pre-wrap", fontSize: 12, color: "#111827" };
